<div class="top-section">
    <h3>
        Vessels
    </h3>
</div>
<section class="rate-request rate-request-sec">
    <div class="middle-section">
        <div class="container">
            <div class="rate-request-form">
                <div class="rate-request-form-inner">
                    <div class="shippinglineslist pRel">
                        <p-dropdown [options]="shippinglineslist" optionLabel="shippingLineName"
                            [(ngModel)]="selectedShippingline" class="p-dropdown" placeholder="Select ShippingLine"
                            [virtualScroll]="true" [itemSize]="31" [filter]="false" (onChange)="onChangeshippingline()"></p-dropdown>
                            <span class="downArrow"><img src="../../../../../assets/images/arrow.png" /></span>

                    </div>
                    <div class="request-btn">
                        <input type="text" class="form-control" pInputText size="50" placeholder="Search"
                            (change)="filterSearch($event.target.value)">
                        <div class="btn-search"><button class="btn  btn-go my-2 my-sm-0" type="submit"><img
                                    src="../../../assets/images/Group 103.svg"></button></div>
                    </div>
                </div>
                <div class="rate-request-form-innera text-end mb-3">
                    <a class="btn btn-signIn"  href="javascript:void(0)" tooltipPosition="top" pTooltip="Add Vessels"
                        (click)="openVesselModal(0, 'add')" data-toggle="modal" (click)="resetvalues()"
                        data-target=".edit-vessels">
                        <i class="fa fa-plus"></i>Add Vessel
                    </a>
                </div>
                <div class="table-responsive rate-request-tbl">
                    <p-table [value]="VesselsData">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>VesselsName</th>
                                <th>CBMCapacity</th>
                                <th>CEUCapacity</th>
                                <th>MisiNumber</th>
                                <!-- <th>ShippingLineName</th> -->
                                <th>Actions</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-vessels>
                            <tr>
                                <td>{{ vessels.vesselsName }}</td>
                                <td>{{ vessels.cbmCapacity }}</td>
                                <td>{{ vessels.ceuCapacity }}</td>
                                <td>{{ vessels.misiNumber }}</td>
                                <!-- <td>{{ vessels.shippingLineName }}</td> -->
                                <td>
                                    <!-- <a class="action-btn " tooltipPosition="top" pTooltip="Add Alias"
                                        data-toggle="modal" data-target=".add-modal" (click)="AddVesselsRequest()">
                                        <svg fill="#000000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"
                                            width="18px" height="18px" fill="#505d6b">
                                            <path
                                                d="M 7.5 1 C 3.917969 1 1 3.917969 1 7.5 C 1 11.082031 3.917969 14 7.5 14 C 11.082031 14 14 11.082031 14 7.5 C 14 3.917969 11.082031 1 7.5 1 Z M 7.5 2 C 10.542969 2 13 4.457031 13 7.5 C 13 10.542969 10.542969 13 7.5 13 C 4.457031 13 2 10.542969 2 7.5 C 2 4.457031 4.457031 2 7.5 2 Z M 7 4 L 7 7 L 4 7 L 4 8 L 7 8 L 7 11 L 8 11 L 8 8 L 11 8 L 11 7 L 8 7 L 8 4 Z" />
                                        </svg>
                                    </a> -->
                                    <!-- <a class="action-btn " tooltipPosition="top" pTooltip="View Vessels"
                                        data-toggle="modal" data-target=".view-vessels"
                                        (click)="getVesselsdetails(vessels.id)">
                                        <i class="fa fa-eye"></i>
                                    </a> -->

                                    <a class="action-btn " tooltipPosition="top" pTooltip="Update Vessel"
                                        data-toggle="modal" data-target=".edit-vessels"
                                        (click)="openVesselModal(vessels.vesselsId, 'edit')">
                                        <i class="fa fa-edit"></i>
                                    </a>

                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <p-paginator *ngIf="totalcount > 0" [rows]="requestVM.pageSize" [rowsPerPageOptions]="[5,10,20]"
                    [totalRecords]="totalcount" (onPageChange)="paginate($event)"></p-paginator>
                <div *ngIf="totalcount == 0">
                    <span>No records found</span>
                </div>
            </div>
        </div>
    </div>
</section>


<!-- Edit Vessels PopUp -->
<ng-template #vesselModal let-modal>
  <div class="modal-header">
    <h3>{{ VesselsId === 0 ? 'Add Vessel' : 'Edit Vessel' }}</h3>
    <button type="button" class="close-btn" aria-label="Close" (click)="modal.dismiss()">
      <span class="pi pi-fw pi-times"></span>
    </button>
  </div>
  <form [formGroup]="VesselsForm">
    <div class="modal-body">
      <div class="col-sm-12">
        <div class="row">
          <div class="col-md-4 form-group">
            <label class="custom-labal "> Vessels Name </label>
            <input type="text" class="form-control" formControlName="vesselsName" [ngClass]="{ 'is-invalid':(submitted && fg.vesselsName.errors) || ( fg.vesselsName.errors && fg.vesselsName.touched) || (fg.vesselsName.errors && fg.vesselsName.dirty)}" />
            <div *ngIf="(submitted && fg.vesselsName.errors) || ( fg.vesselsName.errors && fg.vesselsName.touched) || (fg.vesselsName.errors && fg.vesselsName.dirty)" class="invalid-feedback">
              <div class="port-error " *ngIf="fg.vesselsName.errors.required"> Vessels Name is required</div>
              <div class="port-error " *ngIf="fg.vesselsName.errors.maxlength"> Vessels Name can be max 30 characters long</div>
            </div>
          </div>
          <div class="col-md-4 form-group">
            <label class="custom-labal "> CBMCapacity </label>
            <input type="text" class="form-control" formControlName="cbmCapacity" />
          </div>
          <div class="col-md-4 form-group">
            <label class="custom-labal "> CEUCapacity </label>
            <input type="text" class="form-control" formControlName="ceuCapacity" />
          </div>
          <div class="col-md-4 form-group pt-3">
            <label class="custom-labal "> MisiNumber </label>
            <input type="text" class="form-control" formControlName="misiNumber" />
          </div>
          <div class="col-md-4 form-group pt-3">
            <label class="custom-labal "> ShippingLines </label>
            <div class="shipping-sec">
              <div class="shipping-lines">
                <div class="select-section-relative">
                  <p-multiSelect 
                    [options]="myshippingline" 
                    [(ngModel)]="myselectedshippingline" 
                    placeholder="Select ShippingLine" 
                    formControlName="myshippingline" 
                    [virtualScroll]="true" 
                    [itemSize]="31"
                    optionLabel="shippingLineName">
                  </p-multiSelect>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 form-group pt-3">
            <label class="custom-labal"> Primary ShippingLine </label>
            <div class="pRel">
              <p-dropdown 
                [options]="myselectedshippingline" 
                optionLabel="shippingLineName" 
                formControlName="shippingLine" 
                placeholder="Select ShippingLine" 
                [virtualScroll]="true" 
                [itemSize]="31" 
                [filter]="false">
              </p-dropdown>
              <span class="downArrow">
                <img src="../../../../../assets/images/arrow.png" />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" (click)="addVessel()" class="btn btn-signIn" *ngIf="VesselsId == 0">Save</button>
      <button type="button" (click)="updateVessel()" class="btn btn-signIn" *ngIf="VesselsId > 0">Update</button>
    </div>
  </form>
</ng-template>